export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6507.17e95e93.jpg";